var $ = require('jquery');
require('slick-carousel');

module.exports = function(el) {
    var $el = $(el),
        $vidContainer = $el.find('.vid-quote__vid-container'),
        $quoteContainer = $el.find('.vid-quote__quote-wrap'),
        $thumbNav = $el.find('.vid-quote__thumb-nav');

    $vidContainer.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.vid-quote__thumb-nav'
    });

    $quoteContainer.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.vid-quote__thumb-nav',
        
    });

    // this nav needs to control both the vid container and the quote
    // container
    $thumbNav.slick({
        asNavFor: '.vid-quote__quote-wrap, .vid-quote__vid-container',
        slidesToShow: 3,
        slidesToScroll: 1,
        focusOnSelect: true,
        prevArrow:'<button type="button" class="slick-prev">&larr;</button>',
        nextArrow:'<button type="button" class="slick-next">&rarr;</button>'
        
    });

    $quoteContainer.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
        $vidContainer.slick('slickGoTo', nextSlide);
    });

    $vidContainer.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
        $quoteContainer.slick('slickGoTo', nextSlide);

        // stop current player if it is playing
        VideoPlayer.stop();
    });


    // customize video players after DOM Ready
    $(function() {
        // update global wpme settings
        try{
            window._wpmejsSettings.showPosterWhenEnded = true;
            window._wpmejsSettings.autoRewind = true;

            $vidContainer.find('.mejs-inner').each(function() {
                new VideoPlayer(this);
            });
        }catch (e) {}
    })
};

/**
 * A wrapper around the MediaElements JS Video Player
 * @param el The video element
 * @constructor
 */
function VideoPlayer(el) {
    this.$el = $(el);
    this.videoEl = this.$el.find('video')[0];
    this.player = this.videoEl.player;

    this.init();
}

VideoPlayer.prototype.init = function() {
    this.videoEl.addEventListener('play', this.playHandler.bind(this));
    this.player.hideControls();
};

VideoPlayer.prototype.stop = function() {
    this.player.pause();
    this.player.setCurrentTime(0);
    this.$el.find('.mejs-poster').show();
};

VideoPlayer.prototype.playHandler = function(e) {
    VideoPlayer.currentPlayingPlayer = this;
};

VideoPlayer.stop = function() {
    if (VideoPlayer.currentPlayingPlayer) {
        VideoPlayer.currentPlayingPlayer.stop();
    }
}



//////////////////
// WEBPACK FOOTER
// ./modules/vidQuote.js
// module id = 5
// module chunks = 0